export default {
    title: "Thuis",
    button: {
        accessories: "Blader door de catalogus"
    },
    noAvailableItems: "De randapparatuurportal heeft op dit moment geen items beschikbaar voor uw land. Werk samen met uw manager om de items te kopen die u nodig heeft.<br><br> <a href='#' role='button' data-widget-trigger='{widgetOptions}'>Contact opnemen met ondersteuning</a>",
    error: "Er is een probleem opgetreden bij het ophalen van producten. Herlaad alsjeblieft je browser."
}